import { useSelector, useDispatch } from "react-redux";
import { closeConfirmModal } from "app/store/quickTextTemplates/slice/quickTextTemplateSlice";
import { useDeleteQuickTextTemplateMutation } from "app/store/quickTextTemplates/api/quickTextTemplateApi";
import { showErrorToast, showSuccessToast } from "utils/toast";
import { broadcastQuickTextTemplateData } from "utils/broadcastChannel";

const useQuickTextTemplateConfirmModal = () => {
  const { showConfirmModal, templateToDelete } = useSelector(
    (state) => state.quickTextTemplate
  );
  const dispatch = useDispatch();
  const [deleteQuickTextTemplate, { isLoading: isDeleting }] =
    useDeleteQuickTextTemplateMutation();

  const handleDeleteConfirm = async () => {
    try {
      const response = await deleteQuickTextTemplate(
        templateToDelete?._id
      ).unwrap();

      if (!response.error) {
        broadcastQuickTextTemplateData(true);
        showSuccessToast(response?.message);
      }
    } catch (error) {
      showErrorToast(error?.message || "An error occured, please try later.");
    } finally {
      broadcastQuickTextTemplateData(false);
      dispatch(closeConfirmModal());
    }
  };

  const handleDeleteCancel = () => {
    dispatch(closeConfirmModal());
  };

  return {
    showConfirmModal,
    templateToDelete,
    isDeleting,
    handleDeleteConfirm,
    handleDeleteCancel,
  };
};

export default useQuickTextTemplateConfirmModal;
